import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const MeetingIntelligenceUserSettings = withSafeSuspense(
  lazy(
    async () => ({
      default: (await import('./settings')).MeetingIntelligenceUserSettings
    })
  )
)
